import React from 'react';

import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { TextField } from '@mui/material';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import indexToLetter from '@dyl/utils/indexToLetter';

import Node from './Node';
import { useMicroCheck } from './utils';

export default function Stimulus({ index }) {
    const isMicro = useMicroCheck();
    const [stimulus, setStimulus, stimulusError] = useTaskField('items', index, 'stimulus_text');
    const onStimulusChange = useChangeEvent(setStimulus);

    if (index % 4 === 3) return null;

    return (
        <TextField
            label={`Stimulus ${indexToLetter(index % 4)}${index === 0 ? ' (Example)' : ''}`}
            value={stimulus}
            onChange={onStimulusChange}
            fullWidth
            variant='filled'
            error={!!stimulusError}
            helperText={stimulusError || ' '}
            InputProps={{
                endAdornment: !isMicro ? <Node lineId={index} side='start' /> : undefined,
            }}
        />
    );
}